export default __webpack_public_path__ + "static/media/st.18d2a5b9.svg";